import { render, staticRenderFns } from "./Corp.vue?vue&type=template&id=79903e88&scoped=true&"
import script from "./Corp.vue?vue&type=script&lang=ts&"
export * from "./Corp.vue?vue&type=script&lang=ts&"
import style0 from "./Corp.vue?vue&type=style&index=0&id=79903e88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79903e88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardTitle,VCol})
